import FixedBookingCategory from '$/_const/trip/FixedBookingCategory.ts';
import BookingTypes from '$/_const/trip/WhatHasBeenBookedType.ts';
import type { WhatHasBeenBooked } from '$/requests/TripCreateRequest.ts';

export const newFixedBooking = (): WhatHasBeenBooked => ({
  id: crypto.randomUUID(),
  bookingType: BookingTypes.OTHER,
  category: FixedBookingCategory.WEDDING,
  provider: 'A wedding',
});
